import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { messageDetail } from '@/api/notice.js';
import { mapState } from 'vuex';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import { streamInfo } from '@/api/notice';
import { downloadFileFun } from '@/utils/public';
export default {
  computed: {
    ...mapState({
      systemForcePopMessageList: state => state.message.systemForcePopMessageList,
      timerInstance: state => state.message.timerInstance,
      forceMessageModelVisible: state => state.message.forceMessageModelVisible
    }),
    fileList() {
      var _this$systemForcePopM;
      if ((_this$systemForcePopM = this.systemForcePopMessageList) !== null && _this$systemForcePopM !== void 0 && (_this$systemForcePopM = _this$systemForcePopM[this.index]) !== null && _this$systemForcePopM !== void 0 && _this$systemForcePopM.fileList) {
        return this.systemForcePopMessageList[this.index].fileList;
      } else {
        return [];
      }
    }
  },
  components: {
    previewModal
  },
  data() {
    return {
      visible: false,
      index: 0,
      previewVisible: false,
      previewSrc: '',
      currentPreviewIndex: 0,
      fileType: ''
    };
  },
  watch: {
    systemForcePopMessageList: {
      handler(val) {
        if (val && val.length > 0) {
          this.visible = true;
          this.$store.commit('message/setForceMessageModelVisible', true);
          if (this.timerInstance) {
            clearTimeout(this.timerInstance);
          }
          val.forEach((item, index) => {
            // item.uploadFiles = item.uploadFiles ? JSON.parse(item.uploadFiles) : [];
            let uploadFiles = item.uploadFiles && item.uploadFiles.length > 0 ? JSON.parse(item.uploadFiles) : [];
            // let uploadFiles = item.uploadFiles && item.uploadFiles.length > 0 ? item.uploadFiles : [];
            let annexVariable = item.annexVariable && item.annexVariable.length > 0 ? item.annexVariable : [];
            item.fileList = [...uploadFiles, ...annexVariable];
          });
          messageDetail({
            messageDetailId: val[0].id
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$store.commit('message/setForceMessageModelVisible', false);
      this.$store.dispatch('message/loopPopMessageList', {});
      this.index = 0;
      this.$store.commit('message/SET_SYSTEM_FORCE_POP_MESSAGE_LIST', []);
    },
    next() {
      this.index++;
      // messageDetail({messageDetailId: this.systemForcePopMessageList[this.index].id});
      if (this.index === this.systemForcePopMessageList.length) {
        this.visible = false;
        this.$store.commit('message/setForceMessageModelVisible', false);
        this.cancelPre();
        this.index = 0;
      }
    },
    downLoadImage(item) {
      let link = document.createElement('a');
      link.href = item.url;
      link.setAttribute('download', item.name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async preview(file) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      //excel
      if (isExcel(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式
      if (isWord(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        var _this$systemForcePopM2;
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = (_this$systemForcePopM2 = this.systemForcePopMessageList) === null || _this$systemForcePopM2 === void 0 || (_this$systemForcePopM2 = _this$systemForcePopM2[this.index].fileList) === null || _this$systemForcePopM2 === void 0 ? void 0 : _this$systemForcePopM2.findIndex(item => item.uid === file.uid);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    },
    download(item) {
      let type = item.url.substring(item.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type) || isExcel(type) || isWord(type)) {
        this.downLoadImage(item);
      } else if (isPDF(type) || isVideo(type)) {
        let filetype = isPDF(type) ? 'application/pdf' : isVideo(type) ? 'video/mpeg' : '';
        streamInfo({
          url: item.url
        }).then(res => {
          downloadFileFun(res, filetype, item.name);
        });
      }
    }
  }
};